// extracted by mini-css-extract-plugin
module.exports = {"avatar":"HeaderUserInfo_avatar__uji5i"};